import dynamic from 'next/dynamic';
import React from 'react';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import getThePlaceSlidesByType from '../../src/apollo/graphql/place/getThePlaceSlidesByType';
import { Container } from '../../src/components/Grid';
import {
  Media,
  PushShopping,
  Section,
  VideoCard
} from '../../src/components/Layout';
import { H3 } from '../../src/components/Title';
import { media } from '../../src/styles/media';
import sortByOrder from '../../src/utils/collection/sortByOrder';
import createContext from '../../src/utils/format/createContext';

const SliderComponentWithNoSSR = dynamic(
  import('../../src/components/Slider'),
  {
    loading: () => <p>Loading...</p>,
    ssr: false
  }
);

const Wrapper = styled.div`
  position: relative;

  .slick-slide {
    padding: 0;
    flex: inherit;
  }

  .slick-disabled {
    display: none;
  }

  .slick-track {
    overflow-x: hidden;
  }

  .slick-dots {
    position: initial;
    width: auto;
    margin: ${props => props.theme.layout.gutter}px 0;

    li {
      display: none;
      position: relative;
      background-color: ${props => props.theme.color.darkerWhite};
      width: 10px;
      height: 10px;

      ${media.tablet`
        display: inline-block;
      `};

      button {
        opacity: 0;
        width: 10px;
        height: 10px;
      }

      &:before {
        content: '';
        position: absolute;
        background-color: ${props => props.theme.color.white};
        width: 2px;
        height: 2px;

        left: 50%;
        top: 50%;

        transform: translate3d(-50%, -50%, 0);
      }
      &.slick-active {
        &,
        &:before {
          background-color: ${props => props.theme.color.primary};
        }
      }
    }
  }

  .slick-arrow {
    top: 40vw;
    z-index: 9;
    transform: none;
  }

  .slick-next {
    right: 0;
  }

  .slick-prev {
    left: 0;
  }

  ${media.tablet`
    .slick-slide {
      padding: 10px;
    }
    .slick-arrow {
      top: 50%;
      transform: translate(0,-50%);
    }
    .slick-next {
      right: -25px;
    }

    .slick-prev {
      left: -25px;
    }
  `};
`;

const MediaReverse = styled(Media)`
  flex-direction: row-reverse;
  h2 {
    font-size: ${props => props.smallTitle && '22px'};
  }

  h2,
  p {
    text-align: left;
  }
`;

class Project extends React.PureComponent {
  render() {
    const { page, i18n, t } = this.props;
    return (
      <Section>
        <Container>
          <Wrapper>
            <Fade up>
              <H3 icon="projet" border={true}>
                {t('common:place.rehabilitation')}
              </H3>
            </Fade>
            <Query
              query={getThePlaceSlidesByType}
              variables={{ type: 'project' }}
              context={createContext(i18n.language)}
            >
              {({ loading, error, data }) => {
                if (
                  !loading &&
                  !error &&
                  data &&
                  data.getThePlaceSlidesByType
                ) {
                  const carousel = data.getThePlaceSlidesByType;
                  const orderedCarousel = sortByOrder(carousel);
                  return (
                    <SliderComponentWithNoSSR
                      autoplay={false}
                      autoplaySpeed={5000}
                      slidesToShow={1}
                      slidesToScroll={1}
                      infinite={false}
                      dots={true}
                      unslick={orderedCarousel.length > 1 ? false : true}
                    >
                      {orderedCarousel.map((slide, index) => {
                        return (
                          <MediaReverse
                            key={index}
                            title={slide.detail.title}
                            img={slide.img_media_mobile}
                            imgDesktop={slide.img_media_desktop}
                            smallTitle
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: slide.detail.content
                              }}
                            />
                          </MediaReverse>
                        );
                      })}
                    </SliderComponentWithNoSSR>
                  );
                }

                return null;
              }}
            </Query>
          </Wrapper>
        </Container>

        <VideoCard
          title={page.detail.block_video_title}
          videoSrc="th-ksAgIxQI"
          link={page.detail.block_video_cta_url}
          linkLabel={page.detail.block_video_cta_label}
          background={'/static/images/place/poster.png'}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: page.detail.block_video_content
            }}
          />
        </VideoCard>

        <PushShopping
          link={page.detail.block_push_cta_url}
          title={page.detail.block_push_title}
          label={page.detail.block_push_cta_label}
          background={page.img_bg_desktop}
          backgroundMobile={page.img_bg_mobile}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: page.detail.block_push_content
            }}
          />
        </PushShopping>
      </Section>
    );
  }
}

export default translate()(Project);
